import { Button, Modal, Typography } from '@scale/scaleui';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Routes, buildRoute } from 'react-scale/components/ExpertManagement/urls';
import { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { useFetchWorkersManagers } from '../hooks/queries/useFetchWorkersManagers';
import { CurrentWorkerAssignmentTable } from './CommunityManagement/CommunityManagementTab';
import { SelectWorkerManager } from './SelectWorkerManager';
import { setManagerForWorkers } from './api';

interface MoveToNewManagerModalProps {
  open: boolean;
  onClose: () => void;
  expertIds: string[];
}

export function MoveToNewManagerModal({ open, onClose, expertIds }: MoveToNewManagerModalProps) {
  const history = useHistory();
  const [manager, setManager] = useState<string>('');
  const { mutate, isLoading } = useMutation(() => setManagerForWorkers(manager, expertIds), {
    onSuccess: (res: any) => {
      if (res.success) {
        history.push(buildRoute(Routes.ExpertManagement, { user: manager }));
        onClose();
      } else {
        defaultApiFetchErrorHandler({ name: 'error', message: res.error, logError: () => null });
      }
    },
  });
  const { loading, workerManagers } = useFetchWorkersManagers(open, expertIds);

  return (
    <Modal
      title="Move users to new reviewer"
      open={open}
      onClose={onClose}
      actions={
        <div className="flex items-center gap-2 justify-end">
          <Button onClick={onClose} variant="danger">
            Cancel
          </Button>
          <Button disabled={!manager || isLoading} onClick={() => mutate()}>
            {isLoading ? 'Updating...' : 'Update Reviewer'}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col justify-between" style={{ minHeight: 240 }}>
        <div className="flex flex-col gap-2 mb-2">
          <Typography.Subtitle3>
            Select a new reviewer for the {expertIds.length} selected users.
          </Typography.Subtitle3>
          <SelectWorkerManager
            placeholder="Select a new reviewer for the selected users"
            selectedManagerId={manager}
            setSelectedManagerId={setManager}
          />
        </div>
        <CurrentWorkerAssignmentTable
          workerIds={expertIds}
          workerManagers={workerManagers}
          loading={loading}
        />
      </div>
    </Modal>
  );
}
